import { Layout, Dropdown, Menu, Avatar, Modal, Button, Carousel, Image } from 'antd'
import { useTranslation } from 'next-i18next'
import Link from 'next/link'
import React, { useEffect, useState } from 'react'
import ChangePasswordForm from '../profile/ChangePasswordForm'
import { getRefreshToken, getRole, getToken, getUser, hasRole, logout } from '../../libs/browser'
import { URL_TEMPLATE, USER_ROLES_ENUM } from '../../libs/constant'
import authApi from '../../api/authApi'
import { ComponentValidator } from '../auth/Validator'
import { useModalState } from 'src/hooks/useModalState'
import { getInfo, hasRequiredItem } from 'src/libs/util'
import { useEventTeacherDayVN } from 'src/hooks/useEventTeacherDayVN'
import userApi from 'src/api/userApi'
import Icon, { DownOutlined, UpOutlined, UserOutlined } from '@ant-design/icons'
import { useGetData } from 'src/hooks/useGetData'
import { EVENT_CHANGE_AVATAR } from '../manage/user/edit/AvatarProfile'
import useEventListener from 'src/hooks/useEventListener'
import HeaderRemindTutor from './HeaderRemindTutor'
import HeaderTutor from './HeaderTutor'
import HeaderTeacherDay from './HeaderTeacherDay'
import HeaderTutorRegisterSchedule from './HeaderTutorRegisterSchedule'
import commonApi from 'src/api/commonApi'
import { MODE_SHOW_POPUP } from 'pages/_app'
import useGetWithContext from 'src/hooks/useGetWithContext'
// import { Carousel } from 'react-bootstrap'

function handleLogout() {
  authApi.logout({
    accessToken: getToken(),
    refreshToken: getRefreshToken(),
  })
  logout()
  setTimeout(() => {
    window.open(URL_TEMPLATE.SYSTEM_LOGIN, '_self')
  }, 100)
}

const { Header } = Layout
export function AppHeader({ logo }) {
  const isTeacher = hasRole([USER_ROLES_ENUM.EMPLOYEE_TEACHER]) && getRole().length === 1
  const { isDisplayEvent, eventLink, description } = useEventTeacherDayVN()
  const user = getUser()
  const { data: codeShowModal } = useGetData(commonApi.getCodeModal)

  const { data: userDetail } = useGetWithContext(
    'detail-user',
    userApi.detail,
    user?.userId,
    { isDisabled: !user?.userId },
  )
  const { classType } = getInfo(userDetail?.userInfoData)
  
  const showHeaderRemind = () => {
    switch(codeShowModal) {
      case MODE_SHOW_POPUP.SPEAKING_EXERCISE:
        return <HeaderRemindTutor />
      default:
        return <HeaderTutor />
    }
  }

  if (!isTeacher) {
    return (
      <Header
        className={`site-layout-background d-inline-flex justify-content-${
          logo ? 'between' : 'end'
        } align-items-center`}
        style={{ padding: '0 25px', height: '80px', boxShadow: '0px 2px 6px 0px #1018280F' }}
      >
        {logo}
        <HeaderAvatar isTeacher={isTeacher}/>
      </Header>
    )
  }

  return (
    <Carousel dots={false} autoplay={true}  autoplaySpeed={5000} >
       <Header
          className={`site-layout-background d-inline-flex justify-content-${
            logo ? 'between' : 'end'
          } align-items-center p-0`}
          style={{width: '100%', boxShadow: '0px 2px 6px 0px #1018280F' }}
        >
          <div className='header-layout'>
            {codeShowModal && showHeaderRemind()}
            <HeaderAvatar className='mr-4' isTeacher={isTeacher}/>
          </div>
        </Header>
        {new Date().getDate() < 27 && <Header
          className={`site-layout-background d-inline-flex justify-content-${
            logo ? 'between' : 'end'
          } align-items-center p-0`}
          style={{width: "100%"}}
        >
          <div className='header-layout'>
            <HeaderTutorRegisterSchedule />

            <HeaderAvatar className='mr-4' isTeacher={isTeacher}/>
          </div>
        </Header>}
        {
          // (classType?.includes('REGULAR') || classType?.includes('BACKUP')) && (
          //   <Header
          //     className={`site-layout-background d-inline-flex justify-content-${
          //       logo ? 'between' : 'end'
          //     } align-items-center p-0`}
          //     style={{width: "100%"}}
          //   >
          //     <div className='header-layout-teacher-day'>
          //       <div className='d-flex align-items-center'>
          //         <img src='/image/teacher-day-image.png' alt='Teacher Day' style={{ marginTop: '5px' }} className='teacher-day-image'/>
          //         {/* <img src='/image/teacher-day-text.png' alt='Teacher Day' className='teacher-day-text-new'/> */}
          //         <div className='d-flex align-items-center justify-content-center'>
          //           <span className='teacher-day-text-new'>"Tự hào Gia sư Edupia - Proud to be Edupia Tutor"</span>
          //         </div>
          //         <Link href={`https://drive.google.com/file/d/1uom6FJoyPY7QeIhn6yD1U7SPBt5PX-hC/view`}>
          //           <a target='_blank' style={{ textDecoration: 'none', marginLeft: '30px' }}>
          //             <button className='header-button__use-immediately'>
          //               Khám phá ngay
          //             </button>
          //           </a>
          //         </Link>
          //       </div>
          //       <HeaderAvatar className='d-flex align-items-center mr-4' isTeacher={isTeacher}/>
          //     </div>
          //   </Header>
          // )
        }
    </Carousel>
  )
}

const HeaderAvatar = ({ isTeacher, ...rest }) => {
  const { t } = useTranslation()
  const [currentTime, setCurrentTime] = useState(null)
  const [open, setOpen] = useState(false);
  const { handleClose, handleOpen, isModalVisible } = useModalState()
  const user = getUser()

  const openListener = ({ detail }) => {
    setCurrentTime(detail?.time)
  }

  const { data: userDetail } = useGetWithContext(
    'detail-user',
    userApi.detail,
    user?.userId,
    { isDisabled: !user?.userId },
    [currentTime],
  )

  useEventListener(EVENT_CHANGE_AVATAR, openListener, document)

  const menu = (
    <Menu>
      <ComponentValidator visible={hasRequiredItem(user?.userRoles || [], ['employee-teacher'])}>
        <Menu.Item key={1}>
          <Link href={`${URL_TEMPLATE.SYSTEM_USER_INFORMATION}`}>
            <a style={{ textDecoration: 'none' }}>{t('common.label.user_information')}</a>
          </Link>
        </Menu.Item>
      </ComponentValidator>
      <Menu.Item onClick={handleOpen} key={2}>
        {t('common.label.change_password')}
      </Menu.Item>
      <Menu.Item onClick={handleLogout} key={3}>
        {t('common.label.logout')}
      </Menu.Item>
    </Menu>
  )

  return (
    <span {...rest}>
      {/*  */}
      <ComponentValidator visible={!!user}>
        <div className='d-flex align-items-center' style={{ columnGap: '15px' }}>
          <div>
            {userDetail?.url ? (
              <Avatar
                src={userDetail?.url && `https://static.edupia.vn/${userDetail?.url}`}
                style={{ width: '48px', height: '48px' }}
              />
            ) : (
              <Avatar icon={<UserOutlined />} style={{ width: '48px', height: '48px' }} />
            )}
          </div>
          <div className='d-flex flex-column' style={{lineHeight: '20px'}}>
            {user?.userName && (
              <Link href={URL_TEMPLATE.SYSTEM_PROFILE} className='mx-2'>
                <span style={{ color: isTeacher ? 'white': 'rgba(55, 65, 81, 1)', fontWeight: '600', fontSize: '20px', cursor: 'pointer' }}>{user.userName}</span>
              </Link>
            )}
            <span 
              style={{ 
                color: 'rgba(107, 114, 128, 1)', 
                fontSize: '14px',
                display: 'inline-block',
                maxWidth: '120px',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
              }}
            >
              {user?.userRoles.join(', ')}
            </span>
          </div>
          <Dropdown 
            overlay={menu}
            placement='bottomLeft'
            open={open}
            onVisibleChange={(flag) => setOpen(flag)}
            trigger={['click']}
          >
            <div>
              <Image src='/image/ui-kit/vector-new-icon.png' className={`vector_header_icon ${open ? 'flip' : ''}`} preview={false} style={{ cursor: 'pointer' }}/>
            </div>
          </Dropdown>
        </div>
      </ComponentValidator>
      
      <Modal
        onCancel={handleClose}
        visible={isModalVisible}
        destroyOnClose
        footer={null}
        title={t('common.label.change_password')}
        style={{ minWidth: 350 }}
      >
        <ChangePasswordForm closeModal={handleClose} />
      </Modal>
    </span>
  )
}